import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { IPropertyEditorTextBox, PropertyEditorTextBox, PropertyEditorTextBoxPropertyValues } from "./PropertyEditorTextBox";
import { TextPassword } from "./PropertyEditorTextBoxPassword/TextPassword";
import { TextBox, TextBoxTypeEnum } from "./TextBox";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorTextBoxPasswordPropertyValues =
    PropertyEditorTextBoxPropertyValues
    & {
    };

export type PropertyEditorTextBoxPasswordProperties = {
    [name in keyof PropertyEditorTextBoxPasswordPropertyValues]: Property<PropertyEditorTextBoxPasswordPropertyValues[name]>
};

export interface IPropertyEditorTextBoxPassword extends IPropertyEditorTextBox, PropertyEditorTextBoxPasswordProperties
{
}

export class PropertyEditorTextBoxPassword extends PropertyEditorTextBox implements IPropertyEditorTextBoxPassword
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorTextBoxPassword";
    public static override className = "PropertyEditorTextBoxPassword";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorTextBoxPasswordPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                createEditorControl: () => new TextBox({ maximumLength: 64, type: TextBoxTypeEnum.password }),
                viewControl: new TextPassword(),
            }
        };
    }

    // #endregion

    // #endregion
}
